module.exports = __webpack_public_path__ + "img/testimg.4c7fb98b.jpeg";